export default {
    'create-warehouse': 'إنشاء مستودع',
    'edit-warehouse': 'تعديل مستودع',
    'warehouse-name': 'اسم المستودع',
    notes: 'ملاحظات',
    save: 'حفظ',
    cancel: 'إلغاء',

    'delete-the-warehouse': 'حذف المستودع',
    'are-you-sure-you-want-to-delete-the-warehouse': 'هل أنت متأكد من حذف المستودع؟',
    'create': "سيتم إنشاء",
    "are-you-sure": "هل أنت متأكد؟",
    "contain": "يحتوي على",
    "warehouse-data": "بيانات المستودع",
    "import-materials-from-warehouse": "استيراد مواد من مستودع",
    "imported-materials": "مواد مستوردة من",
    "no-imported-materials":"دون استيراد أية مواد",
    "creating-warehouse": "يتم حاليا انشاء المستودع",
    "warehouse-created-successfully": "تم إنشاء المستودع بنجاح<i class='fas fa-check primary--text mt-1 mx-1'></i>. يتم حاليا استيراد المواد...",
    "link-materials": "ربط المواد",
    "link-materials-alert": "سيتم ربط المواد في المستودع الجديد تلقائيًا مع جميع المستودعات المرتبطة ببعضها حاليًا. هذا يعني أن أي تعديل على المواد المرتبطة سيُطبَّق على جميع المستودعات المتصلة.",
    "search-and-select-material": "بحث وتحديد مادة",
    headers: {
        'no': 'الرقم',
        'warehouse-name': 'اسم المستودع',
        'notes': 'الملاحظات',
        'actions': 'الأحداث',
    }
}